import { redstone } from './chains/redstone';

export const activeChainId = process.env.NEXT_PUBLIC_L2_CHAIN_ID
  ? Number(process.env.NEXT_PUBLIC_L2_CHAIN_ID)
  : redstone.id;

export const activeL1ChainId = process.env.NEXT_PUBLIC_L1_CHAIN_ID
  ? Number(process.env.NEXT_PUBLIC_L1_CHAIN_ID)
  : 1;
